/** Shared pending operations outrank a successful refresh or one settled edit. */
export function resolveGnomeCustomizationSync(
    pendingMutationCount: number,
    outcome: "ready" | "error",
    completingMutation = false,
): {
    pendingMutationCount: number;
    syncStatus: "saving" | "ready" | "error";
} {
    const pending = Math.max(
        0,
        pendingMutationCount - Number(completingMutation),
    );
    return {
        pendingMutationCount: pending,
        syncStatus: pending > 0 ? "saving" : outcome,
    };
}

/** Versions are canonical positive integer strings and may exceed safe Number range. */
export function isCurrentGnomeSnapshotVersion(
    incomingVersion: string,
    currentVersion: string | undefined,
): boolean {
    return (
        currentVersion === undefined ||
        BigInt(incomingVersion) >= BigInt(currentVersion)
    );
}
